<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Coil Options</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (coilUnionsSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Unions on Coil:</label>
            <select class="halfWidthInputField" #coilUnionsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(coilUnionsSelection.Name)"
              (change)="selectionChanged(coilUnionsSelection, coilUnionsInput.value)"
              [value]="coilUnionsSelection.Value.toString()">
              @for (allowable of coilUnionsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="coilUnionsSelection.Value && coilUnionsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (autoAirVentsSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(autoAirVentsSelection.Name)"
            for="autoVentsInput" class="halfWidthInputLabel">Auto Air Vents:</label>
            <input type="checkbox" class="checkboxInput" id="autoVentsInput"
              #autoVentsInput [checked]="'true' === autoAirVentsSelection.Value"
              (change)="selectionChanged(autoAirVentsSelection, autoVentsInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (coilConstructionSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Coil Construction:</label>
            <select class="halfWidthInputField" #coilConstructionInput
              [class.invalidConfigurationSelection]="isInvalidSelection(coilConstructionSelection.Name)"
              (change)="selectionChanged(coilConstructionSelection, coilConstructionInput.value)"
              [value]="coilConstructionSelection.Value.toString()">
              @for (allowable of coilConstructionSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="coilConstructionSelection.Value && coilConstructionSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (drainValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(drainValveSelection.Name)"
            for="drainValveInput" class="halfWidthInputLabel">Drain Valve:</label>
            <input type="checkbox" class="checkboxInput" id="drainValveInput"
              #drainValveInput [checked]="'true' === drainValveSelection.Value"
              (change)="selectionChanged(drainValveSelection, drainValveInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (testPressureSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Test Pressure:</label>
            <select class="halfWidthInputField" #testPressureInput
              [class.invalidConfigurationSelection]="isInvalidSelection(testPressureSelection.Name)"
              (change)="selectionChanged(testPressureSelection, testPressureInput.value)"
              [value]="testPressureSelection.Value.toString()">
              @for (allowable of testPressureSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="testPressureSelection.Value && testPressureSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (oppositeEndCoilConnectionsSelection) {
          <span class="halfWidthConfigurationInput">
            <label
              [class.invalidConfigurationSelection]="isInvalidSelection(oppositeEndCoilConnectionsSelection.Name)"
            for="oppositeEndsInput" class="halfWidthInputLabel">Opposite End Coil Connections:</label>
            <input type="checkbox" class="checkboxInput" id="oppositeEndsInput"
              #oppositeEndsInput [checked]="'true' === oppositeEndCoilConnectionsSelection.Value"
              (change)="selectionChanged(oppositeEndCoilConnectionsSelection, oppositeEndsInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput"></span>
        @if (refrigerantLeakDetectionSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(refrigerantLeakDetectionSelection.Name)"
            for="drainValveInput" class="halfWidthInputLabel">Refrigerant Leak Detection:</label>
            <input type="checkbox" class="checkboxInput" id="refrigerantLeakDetectionInput"
              #refrigerantLeakDetectionInput [checked]="'true' === refrigerantLeakDetectionSelection.Value"
              (change)="selectionChanged(refrigerantLeakDetectionSelection, refrigerantLeakDetectionInput.checked.toString())">
          </span>
        }
      </div>
    </div>
  }
</div>
